import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'search', 'filter' ]

  connect() {
    this.locations = document.querySelectorAll('.locations .column');
    this.pixels    = document.querySelectorAll('.pixel')
    this.visible_pixels = [];
    this.filter();
  }

  search() {
    // Reset buttons
    var filters = this.filterTargets;
    for (var i = 0; i < filters.length; i++) {
      filters[i].classList.remove('is-active');
    }

    // Search
    var input = event.currentTarget;
    var search_string = input.value.toUpperCase();

    // Filter location cards
    for (var i = 0; i < this.locations.length; i++) {
      var txtValue = this.locations[i].innerText;
      var location_id = this.locations[i].dataset.locationId;
      if (txtValue.toUpperCase().indexOf(search_string) > -1) {
        this.locations[i].classList.remove('is-hidden');
        this.visible_pixels.push(document.querySelector(`.pixel[ids~="${location_id}"]`))
      } else {
        this.locations[i].classList.add('is-hidden');
      }
    }

    this.update_map()

    if ( document.querySelectorAll('.locations .column.is-hidden').length == this.locations.length ) {
      document.querySelector('.section__hint').classList.remove('is-hidden');
    } else {
      document.querySelector('.section__hint').classList.add('is-hidden');
    };
  }

  filter() {

    // Reset search
    var input = this.searchTarget;
    input.value = '';

    // Filter
    var filters = this.filterTargets;
    if (event == null || event.currentTarget == document) {
      var urlParams = new URLSearchParams(window.location.search);
      var key = urlParams.get('krav-maga');
      var input = document.querySelector("[data-filter='"+key+"']");
    } else {
      var input = event.currentTarget;
    }

    if (input != null) {
      if (input.classList.contains('is-active')) {
        input.classList.remove('is-active');
        this.reset();
      } else {
        var product_key = input.dataset.filter;

        for (var i = 0; i < filters.length; i++) {
          if (filters[i] == input) {
            filters[i].classList.add('is-active');
          } else {
            filters[i].classList.remove('is-active');
          }
        }

        for (var i = 0; i < this.locations.length; i++) {
          var product_keys = this.locations[i].dataset.products;
          var location_id  = this.locations[i].dataset.locationId;
          if (product_keys.indexOf(product_key) > -1) {
            this.locations[i].classList.remove('is-hidden');
            this.visible_pixels.push(document.querySelector(`.pixel[ids~="${location_id}"]`))
          } else {
            this.locations[i].classList.add('is-hidden');
          }
        }
        this.update_map()
      }
    }
  }

  reset() {
    for (var i = 0; i < this.locations.length; i++) {
      this.locations[i].classList.remove('is-hidden');
    }
    for (var i = 0; i < this.pixels.length; i++) {
      this.pixels[i].classList.remove('is-filtered');
    }
  }

  update_map() {
    for (var i = 0; i < this.pixels.length; i++) {
      var pixel = this.pixels[i];
      pixel.classList.add('is-filtered')
    }
    for (var i = 0; i < this.visible_pixels.length; i++) {
      var pixel = this.visible_pixels[i];
      pixel.classList.remove('is-filtered')
    }
    this.visible_pixels = [];
  }
}
